/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions} from 'angular';

declare let require: any;
declare let angular: any;
import ITranslateService = angular.translate.ITranslateService;

export class DVLanguageSelectComponentConfig implements IComponentOptions {
    transclude = false;
    template = require('./dv-languageselect.html');
    controller = DVLanguageSelectController;
    controllerAs = 'vm';
}

export class DVLanguageSelectController {

    static $inject: any[] = ['CONSTANTS', '$translate'];
    /* @ngInject */
    constructor(private CONSTANTS: any, private $translate: ITranslateService) {
    }

    private langDe() {
        this.$translate.use('de');
    }

    private langFr() {
        this.$translate.use('fr');
    }

    private langIt() {
        this.$translate.use('it');
    }

    public changeLang(lang: string) {
        this.$translate.use(lang);
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-languageselect/dv-languageselect.ts